import cfdTradingContent from './content/cfd-trading.json';

const cfdTradingMock = {
    layoutType: 2,
    data: {
        name: 'cfd-trading',
        layoutType: 2,
        areasList: [
            {
                id: 'cfd-trading-page-area',
                name: 'Content',
                componentName: 'Comp:CfdTradingPage',
                content: JSON.stringify(cfdTradingContent),
            },
        ],
    },
};

export default cfdTradingMock;
